import Backbone from 'backbone';

const tourHeaderSearchFormSelector = '[data-tour-header] [data-search-form]';
const tourHeaderSelectorMobile = `[data-header-mobile] ${tourHeaderSearchFormSelector}`;
const tourHeaderSelectorDesktop = `[data-header-desktop] ${tourHeaderSearchFormSelector}`;

const TourStopSearchForm = Backbone.View.extend({
  events: {
    "click [data-icon-close]": "onClickClose",
    "input [data-input-search]": "onInputChanged",
    "submit": "onSubmit",
  },
  initialize: function() {
    this.allStopNumbers = window?.MoMA?.AvailableStopNumbers || [];
    this.input = this.$("[data-input-search]")[0];
    this.iconGlass = this.$("[data-icon-glass]")[0];
    this.iconClose = this.$("[data-icon-close]")[0];
    this.error = this.$("[data-error]")[0];

    this.onInputChanged();
    this.onInitialize();
  },
  onInitialize() {
    if (this.input.value === '') return;
    if (!this.allStopNumbers.includes(this.input.value)) {
      this.error.classList.remove('layout/none');
    }
  },
  onClickClose() {
    this.input.value = '';
    this.onInputChanged();
    this.error.classList.add('layout/none');
  },
  onInputChanged() {
    if (this.input.value !== '') {
      this.iconClose.classList.remove('layout/none');
      this.iconGlass.classList.add('layout/none');
    } else {
      this.iconGlass.classList.remove('layout/none');
      this.iconClose.classList.add('layout/none');
    }
  },
  onSubmit(e) {
    if (this.input.value === '') return false;
    if (!this.allStopNumbers.includes(this.input.value)) {
      e.preventDefault();
      this.error.classList.remove('layout/none');
    }
  },
  dispose() {
    this.onClickClose();
    this.undelegateEvents();
  }
});

export { TourStopSearchForm, tourHeaderSelectorMobile, tourHeaderSelectorDesktop };